import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useTime, useMaps } from "../_contexts";
import ReactTooltip from "react-tooltip";

import {
  TimelinesContainer,
  HistoryDial,
  HistoryNavbar,
  InteractiveModeOverlay,
} from "./";

export function HistoryContainer() {
  console.log("History Container Render");
  const {
    calendar,
    setCalendar,
    setCurrentDate,
    granularity,
    setGranularity,
    setUnitsDisplay,
  } = useTime();

  const { data: chronicle } = useSelector((state) => state.chronicle);
  const { items: timelines } = useSelector((state) => state.timelines);
  const { details: world } = useSelector((state) => state.world);

  const parentRef = useRef();
  const containerRef = useRef();

  const { interactiveMode } = useMaps();

  useEffect(() => {
    if (chronicle && chronicle !== undefined) {
      const defaultCalendar = chronicle ? chronicle.defaultCalendar : null;
      if (defaultCalendar && defaultCalendar._id) {
        if (!calendar || calendar._id !== defaultCalendar._id) {
          setCalendar(defaultCalendar);
        }

        if (chronicle && chronicle.unitDisplayCount) {
          setUnitsDisplay(chronicle.unitDisplayCount);
        }
      }
      if (chronicle && chronicle.startDate) {
        setCurrentDate(chronicle.startDate);
      } else {
        setCurrentDate("0");
      }
      setGranularity(
        granularity || chronicle?.defaultUnit ? chronicle.defaultUnit : "year"
      );
    }
  }, [chronicle]);

  ReactTooltip.rebuild();

  return (
    <div className="chronos-history-container" ref={parentRef}>
      {chronicle && calendar && calendar !== null && granularity && (
        <HistoryDial
          calendar={calendar}
          granularity={granularity}
          displayUnits={chronicle.unitDisplayCount}
        />
      )}

      {chronicle && calendar && calendar !== null && granularity && (
        <React.Fragment>
          <TimelinesContainer
            parentRef={parentRef}
            timelines={timelines}
            chronicle={chronicle}
            containerRef={containerRef}
            world={world}
            showUTD
          />
          <HistoryNavbar chronicle={chronicle} parent={containerRef} />
          {interactiveMode && <InteractiveModeOverlay />}
        </React.Fragment>
      )}
      <ReactTooltip id="chronos-event-tooltip" effect="float" html={true} />
    </div>
  );
}
